import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../Firebase";
import { V3Room, V3Event } from "../types/v3types";
import V3Screen from "./V3Screen";
import V3KachidokiScreen from "./V3KachidokiScreen";
import styled from "styled-components";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 24px;
  color: #666;
`;

const V3ScreenWrapper: React.FC = () => {
  const { roomId } = useParams<{ roomId: string }>();
  const [room, setRoom] = useState<V3Room | null>(null);
  const [event, setEvent] = useState<V3Event | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRoomAndEvent = async () => {
      if (!roomId) return;

      try {
        // Load room data
        const roomDoc = await getDoc(doc(db, "v3rooms", roomId));
        if (roomDoc.exists()) {
          const roomData = roomDoc.data() as V3Room;
          setRoom(roomData);

          // Load event data
          if (roomData.eventId) {
            const eventDoc = await getDoc(doc(db, "v3events", roomData.eventId));
            if (eventDoc.exists()) {
              const eventData = eventDoc.data() as V3Event;
              setEvent(eventData);
            }
          }
        }
      } catch (error) {
        console.error("Error loading room/event data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadRoomAndEvent();
  }, [roomId]);

  if (loading) {
    return <LoadingContainer>読み込み中...</LoadingContainer>;
  }

  if (!room || !event) {
    return <LoadingContainer>ルームが見つかりません</LoadingContainer>;
  }

  // Check if this is a KACHIDOKI event
  if (event.eventType === "kachidoki") {
    return <V3KachidokiScreen />;
  }

  // Otherwise, use the standard screen
  return <V3Screen />;
};

export default V3ScreenWrapper;